// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"RIRealEstateHomepageApp_dropzone__3hSeg","loader":"RIRealEstateHomepageApp_loader__1BKKL","load3":"RIRealEstateHomepageApp_load3__3UhWw"};